// Appointment Bookings (AMER-5218) — the `appointment-bookings.*` rows, menu item 70.
export const APPOINTMENT_BOOKINGS_INDEX = 1664;
export const APPOINTMENT_BOOKINGS_UPDATE = 1665;
export const APPOINTMENT_BOOKINGS_CONVERT = 1666;
export const APPOINTMENT_BOOKINGS_DELETE = 1667;
export const APPOINTMENT_BOOKINGS_RESTORE = 1668;
export const APPOINTMENT_BOOKINGS_MANAGE_SETTINGS = 1669;
